import { useQuery } from '@tanstack/react-query';
import { NOTIFICATIONS_COUNT_QUERY_KEY } from 'Data/keys/QueryKeys';
import { NotificationApiV2 } from 'Data/Notification.api.v2';

export const useQueryCountNewNotifications = () => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [NOTIFICATIONS_COUNT_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const response = await NotificationApiV2.countNewNotifications();
      return response.data.data.count;
    },
  });

  return {
    data: data ?? 0,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
